module.exports = __webpack_public_path__ + "img/colrave_md.9f547b94.jpg";